import { render, staticRenderFns } from "./ModalFairGame.vue?vue&type=template&id=1b10e40f&scoped=true"
import script from "./ModalFairGame.vue?vue&type=script&lang=js"
export * from "./ModalFairGame.vue?vue&type=script&lang=js"
import style0 from "./ModalFairGame.vue?vue&type=style&index=0&id=1b10e40f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b10e40f",
  null
  
)

export default component.exports